import { useEffect, useState } from "react";
import { STALE_BUILD_EVENT, installStaleServerFunctionGuard } from "@/lib/stale-server-fn";

/**
 * Aviso não-bloqueante quando o browser mantém um bundle antigo. Nunca deixa
 * ecrã branco: a aplicação continua visível e o utilizador pode atualizar.
 */
export function StaleBuildNotice() {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    installStaleServerFunctionGuard();
    const handler = () => setStale(true);
    window.addEventListener(STALE_BUILD_EVENT, handler);
    return () => window.removeEventListener(STALE_BUILD_EVENT, handler);
  }, []);

  if (!stale) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] border-t border-border bg-card/95 p-3 text-sm shadow-lg backdrop-blur">
      <div className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-3 text-center">
        <span className="text-muted-foreground">
          Está a correr uma versão antiga da aplicação neste dispositivo.
        </span>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground hover:bg-primary/90"
        >
          Atualizar aplicação
        </button>
      </div>
    </div>
  );
}
